module.exports = __webpack_public_path__ + "application/directives/input-types/input-types.template.html";